import { render, staticRenderFns } from "./DdUriageSummaryDisp.vue?vue&type=template&id=1c0f0a67&scoped=true&"
import script from "./DdUriageSummaryDisp.vue?vue&type=script&lang=js&"
export * from "./DdUriageSummaryDisp.vue?vue&type=script&lang=js&"
import style0 from "./DdUriageSummaryDisp.vue?vue&type=style&index=0&id=1c0f0a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f0a67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRadio,VRadioGroup,VRow})
